import React, { useEffect } from 'react'
import { useDispatch, connect } from 'react-redux'

// ui-kit
import { useWindowSize } from '@navent-jobs/ui-kit/hooks/window-size'
import { MainContainer, Row, Col } from '@navent-jobs/ui-kit/components/grid'

// mixins
import { BreadcrumbContainer, BreadcrumbComponent } from './mixins'

// redux
import { getBreadcrumbs } from '../../../../redux/actions/breadcrumbs'

// utils
import { formatFilters } from './utils'

const Breadcrumbs = ({ links, activeAviso }) => {
  const dispatch = useDispatch()
  const { isTabletLandscape, isDesktop } = useWindowSize()

  const isDesktopOrTabletLandscape = isDesktop || isTabletLandscape
  const ID_MODALIDAD_REMOTA = 4

  useEffect(() => {
    if (activeAviso) {
      let filtros = ['area', 'subarea', 'provincia', 'localidad', 'modalidad_trabajo', 'apto_discapacitado']
      if (activeAviso.modalidadTrabajo && activeAviso.modalidadTrabajo.id === ID_MODALIDAD_REMOTA) {
        // Eliminar ubicacion de los filtros que se muestran en el breadcrumb si el aviso es internacional
        filtros = filtros.filter(filtro => filtro !== 'provincia' && filtro !== 'localidad')
      }
      dispatch(getBreadcrumbs(formatFilters(activeAviso, filtros)))
    }
  }, [activeAviso])

  if (!activeAviso || activeAviso?.origenAviso === 'ZONAJOBS') {
    return null
  }

  return (
    <BreadcrumbContainer isDesktopOrTabletLandscape={isDesktopOrTabletLandscape}>
      <MainContainer>
        <Row>
          <Col>
            <BreadcrumbComponent links={links} currentTitle={activeAviso.titulo} />
          </Col>
        </Row>
      </MainContainer>
    </BreadcrumbContainer>
  )
}

const states = ({ activeAvisoStore, breadcrumbsStore }) => ({
  links: breadcrumbsStore.breadcrumbs?.links,
  activeAviso: activeAvisoStore.aviso,
})

export default connect(states)(Breadcrumbs)
